
// sticky video
class PointsChartComponents extends HTMLElement {
  constructor() {
    super();
    this.redeemRewards = this.querySelector('.js-points-btn');
    this.rewardsPoints = this.querySelector('.js-rewards-points');

    this.redeemRewards.addEventListener('click', (event) => {
      event.preventDefault();
      this.rewardsPoints.click();

      // Rewards popup trigger
      document.querySelector(".c-launchBubble-button").click();
    });
  }
  
  connectedCallback() {
    const mutationConfig = { attributes: true, childList: true };
    function onMutationChangeCallack(mutationConfigList) {
      for(const mutationConfig of mutationConfigList) {
        if(mutationConfig.type === 'attributes') {
          console.log(`${mutationConfig.attributeName} attribute changed`);
        } else if(mutationConfig.type === 'childList') {
          const pointsChart = document.querySelector('points-chart');
          const rewardsPoints = parseInt(document.querySelector('.js-rewards-points').textContent.replace(' points', ''));

          // Calculate the percentage based on rewardsPoints (clamped between 0 and 2500) and set the custom property.
          const rewardsPercentage = Math.min(100, (rewardsPoints / 2500) * 100);
          pointsChart.style.setProperty('--current-progress-points', `${rewardsPercentage}%`);
          rewardsPercentage === 100 ? pointsChart.classList.add('points__chart-updated', 'points__chart-full') : pointsChart.classList.add('points__chart-updated');
        }
      }
    }
    const observer = new MutationObserver(onMutationChangeCallack);
    observer.observe(this.rewardsPoints, mutationConfig);
  }
}

customElements.define('points-chart', PointsChartComponents);